import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/temi.css";
import { avviaTema } from "@/lib/tema";
import App from "@/App";

// Il tema si mette prima di disegnare, altrimenti la pagina compare chiara e
// diventa scura un attimo dopo.
avviaTema();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
